import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const Store = props => {
  return (
    <SvgIcon {...props} width="29.795" height="25.915" viewBox="0 0 29.795 25.915">
      <path
        d="M8.88,5.175H6.95a.722.722,0,0,1,0-1.435H8.88a.722.722,0,0,1,.062,1.435Z"
        transform="translate(0.229 0.13)"
      />
      <path
        d="M24.795,16.765H7.012a.712.712,0,0,1-.7-.6L4.38,4.576a.713.713,0,0,1,1.4-.248h0L7.621,15.361H24.795A1.858,1.858,0,0,0,26.632,13.8L28.066,5.2H24.4a.713.713,0,0,1-.052-1.424h4.562a.712.712,0,0,1,.712.712.423.423,0,0,1,0,.114l-1.579,9.423A3.261,3.261,0,0,1,24.795,16.765Z"
        transform="translate(0.166 0.13)"
      />
      <path
        d="M5.223,5.284a.7.7,0,0,1-.7-.588L4.232,2.983A1.858,1.858,0,0,0,2.4,1.424H.713A.713.713,0,1,1,.661,0H2.4A3.282,3.282,0,0,1,5.646,2.745l.279,1.713a.712.712,0,0,1-.588.826H5.223Z"
        transform="translate(0.025 0.01)"
      />
      <path
        d="M26.272,19.623H9.677a3.282,3.282,0,0,1-3.251-2.745L6.25,15.846a.713.713,0,1,1,1.4-.248h0l.175,1.032A1.858,1.858,0,0,0,9.677,18.2H26.283a.712.712,0,1,1,0,1.424Z"
        transform="translate(0.226 0.492)"
      />
      <path
        d="M23.863,25.265A2.652,2.652,0,1,1,26.5,22.612a2.652,2.652,0,0,1-2.642,2.652Zm0-3.87a1.239,1.239,0,1,0,.041,0Z"
        transform="translate(0.706 0.65)"
      />
      <path
        d="M9.512,25.265a2.632,2.632,0,1,1,1.882-.771,2.652,2.652,0,0,1-1.882.771Zm0-3.87a1.218,1.218,0,1,0,1.218,1.218,1.218,1.218,0,0,0-1.218-1.218Z"
        transform="translate(0.246 0.65)"
      />
      <path
        d="M16.523,14.315a7.163,7.163,0,1,1,7.152-7.163,7.163,7.163,0,0,1-7.152,7.163Zm0-12.88a5.728,5.728,0,1,0,5.718,5.718h0a5.728,5.728,0,0,0-5.718-5.728Z"
        transform="translate(0.326 0.01)"
      />
      <path
        d="M16.312,10.322A.712.712,0,0,1,15.6,9.61h0V4.45a.722.722,0,0,1,1.435,0V9.61a.712.712,0,0,1-.722.712Z"
        transform="translate(0.527 0.133)"
      />
      <path
        d="M18.973,7.664h-5.16a.713.713,0,0,1-.052-1.424h5.16a.722.722,0,0,1,.743.691.712.712,0,0,1-.691.733Z"
        transform="translate(0.446 0.21)"
      />
    </SvgIcon>
  );
};

export default Store;
